export default __webpack_public_path__ + "static/media/svg-4.20750a9d.svg";